import { useEffect } from 'react';
import type InventoryConditionalTile from '~/contracts/srp/InventoryConditionalTile';
import {
  getNewCarHref,
  getNewCarVariant,
  NewCarVariant
} from '~/utilities/srp/new-car/getNewCarVariant';
import GenericBanner from './GenericBanner';
import MakeBanner from './MakeBanner';
import MakeModelBanner from './MakeModelBanner';
import { PromoBanners } from '../constants';
import { useSendViewedBannerEvent } from '../hooks';
import { getBannerName } from '../utils';

type OwnProps = {
  tileMetadata: InventoryConditionalTile['tileMetadata'];
};

const bannerName = getBannerName(PromoBanners.NewCar);

export default function NewCarBanner({ tileMetadata }: OwnProps) {
  const sendViewedBannerEvent = useSendViewedBannerEvent();
  const href = getNewCarHref(tileMetadata);
  const variant = getNewCarVariant(tileMetadata);

  useEffect(() => {
    sendViewedBannerEvent(bannerName, { variant });
  }, [sendViewedBannerEvent, variant]);

  switch (variant) {
    case NewCarVariant.Make:
      return (
        <MakeBanner
          bannerName={bannerName}
          href={href}
          make={tileMetadata?.make ?? ''}
          variant={variant}
        />
      );
    case NewCarVariant.MakeModel:
      return (
        <MakeModelBanner
          bannerName={bannerName}
          href={href}
          make={tileMetadata?.make ?? ''}
          model={tileMetadata?.model ?? ''}
          variant={variant}
        />
      );
    case NewCarVariant.Generic:
    default:
      return (
        <GenericBanner bannerName={bannerName} href={href} variant={variant} />
      );
  }
}
